<template>
  <div
    style="padding-left: 2%; padding-right: 2%; padding-bottom: 2%; background-color: #F8F9FA; min-height: 100vh; height: 100%;"
  >
    <!-- <Title /> -->
    <OverlayLoading :loading="loading" />
    <v-row class="d-flex align-center ml-0 pt-2">
      <!-- <img
        width="17"
        height="17"
        src="@/assets/icons/back-icon.png"
        class="mt-0 ml-0"
        style="cursor: pointer;"
        @click="goBack()"
      /> -->
      <span class="header-title">
        ข้อมูลส่วนตัวพนักงาน
      </span>
      <v-spacer />
      <!-- <div class="mr-4 action-top-btn">
        <v-btn
          width="100"
          class="ma-0 mr-2"
          outlined
          color="#3776E9"
          dark
          @click="cancel()"
          >ยกเลิก</v-btn
        >
        <v-btn
          width="100"
          class="ma-0 ml-2"
          color="#3776E9"
          :dark="valid"
          :disabled="!valid"
          @click="checkSubmit()"
          >บันทึกข้อมูล</v-btn
        >
      </div> -->
    </v-row>
    <v-card height="auto" min-height="82vh" class="pt-7 pb-7" elevation="0" style="border-radius: 24px;">
      <v-container fluid pa-0 >
          <v-row align="center" justify="center" >
            <div class="pt-1 pb-4 rounded-0" style="min-width:50vw; width:70vw; max-width:100vw;">
              <div class="text-left">
                <span class="text-head-back-all mr-5">ข้อมูลส่วนตัว</span>
              </div>
              <v-divider class="mt-1 mb-4"/>
              <div class="mt-1" justify="start">
                <v-row no-gutters class="mt-5">
                <v-col
                  cols="12"
                  lg="2"
                  md="2"
                  sm="12"
                  class="d-flex flex-column align-start justify-center"
                  style="margin-top: -4%;"
                >
                  <div v-if="valid === true">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="box-employeeimg ml-0 mt-4"
                          @click="ChooseBanner()"
                          style="height: 150px; width: 140px; background-size: contain;"
                        >
                          <!-- <span
                          v-if="!imageUrl"
                          class="placeholder"
                        >
                          เลือกรูปภาพ
                        </span> -->
                          <div class="pa-0 box-placeholderimg">
                            <div
                              class="placeholderimg"
                              :style="{ 'background-image': `url(${imageUrl})` }"
                            >
                              <!-- <v-img
                              width="70"
                              height="70"
                              contain
                              :src="!imageUrl ? require('@/assets/employee/add-image-gray.png') : require('@/assets/employee/add-image-lightgray.png')"
                              aspect-ratio="1"
                            /> -->
                              <v-img
                                v-if="!imageUrl"
                                width="70"
                                height="70"
                                contain
                                :src="require('@/assets/icons/no_user.png')"
                                aspect-ratio="1"
                              />
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                :disabled="!valid"
                                accept="image/*"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                      <span class="" v-if="imageUrl && valid === true"
                        >คลิกเพื่อเลือกรูปใหม่</span
                      >
                      <span class="" v-if="!imageUrl">คลิกเพื่อเลือกรูป</span>
                    </v-tooltip>
                  </div>

                  <!-- ดูเฉยๆ -->

                  <div v-if="valid === false">
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"> -->
                    <div
                      class="box-employeeimg ml-0 mt-4"
                      style="height: 150px; width: 140px; background-size: contain;"
                    >
                      <div class="pa-0 box-placeholderimg">
                        <div
                          class="placeholderimg"
                          :style="{ 'background-image': `url(${imageUrl})` }"
                        >
                        </div>
                      </div>
                    </div>
                  </div>

                  <span class="label-codeid txt-font mt-5 mb-4"
                    >รูปภาพประจำตัว</span
                  >
                </v-col>
                <v-col cols="12" lg="8" md="8" sm="12" class="ml-0">
                  <v-row>
                    <v-col cols="12" lg="5" md="5" sm="5">
                      <p class="txt-font" style="margin-top: 0%;">
                        ชื่อ-นามสกุล (ภาษาไทย)
                      </p>
                      <span class="txt-font" style="color: #333;"
                        >{{titleTH}}{{ fnameTH }} {{ lnameTH }}</span
                      >
                    </v-col>
                    <v-col
                      cols="12"
                      lg="7"
                      md="7"
                      sm="7"
                      class="justify-start align-start"
                    >
                      <p class="txt-font" style="margin-top: 0%;">
                        ชื่อ-นามสกุล (ภาษาอังกฤษ)
                      </p>
                      <span class="txt-font" style="color: #333;"
                        >{{titleEN}}. {{ fnameEN }} {{ lnameEN }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" lg="5" md="5" sm="5">
                      <p class="txt-font" style="margin-top: 0%;">วันเกิด</p>
                      <span class="txt-font" style="color: #333;">{{
                        formatBirthDate(birthDate)
                      }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="7"
                      md="7"
                      sm="7"
                      class="justify-start align-start"
                    >
                      <p class="txt-font" style="margin-top: 0%;">อีเมล</p>
                      <span class="txt-font" style="color: #333;">{{
                        email
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" lg="5" md="5" sm="5">
                      <p class="txt-font" style="margin-top: 0%;">
                        เบอร์โทรศัพท์
                      </p>
                      <span class="txt-font" style="color: #333;">{{ tel }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="7"
                      md="7"
                      sm="7"
                      class="justify-start align-start"
                    >
                      <p class="txt-font" style="margin-top: 0%;">Account ID</p>
                      <span class="txt-font" style="color: #333;">{{
                        accountId
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-row>
        <v-row align="center" justify="center" class="mt-6">
          <div class="pt-1 pb-4 rounded-0" style="min-width:50vw; width:70vw; max-width:100vw;">
            <div class="text-left">
              <span class="mr-5 text-head-back-all">ข้อมูลส่วนตัว</span>
            </div>
            <div v-for="(input,k) in companyData" :key="k">
              <v-divider class="mt-1 mb-4"/>
              <v-card class="px-3 pb-5" elevation="2" style="border-radius: 6px">
                <div>
                  <v-row style="background-color:#EFF4FD; border-radius: 6px;">
                    <v-col cols="12">
                      <v-col
                        cols="12"
                        class="pt-0 pa-1 d-flex flex-row justify-start"
                      >
                        <span class="txt-head">ลำดับที่ {{k+1}}</span>
                      </v-col>
                    </v-col>
                  </v-row>
                        <div class="manage-department-title level-title mx-3">ระดับความน่าเชื่อถือ</div>
                          <v-row  class="mt-4 mx-4" justify="start" align="start">
                             <v-col cols="12" class="d-flex" style="justify-content: center; align-items: center;padding-left:0px">
                              <!-- <span style="font-size:20px">{{ moods[0].emoji }}</span> -->
                              <v-progress-linear
                                :value="level_bar[k]"
                                color="#4CAF50"
                                height="25">
                                <template v-slot:default="{ value }">
                                  <!-- พนักงานภายใน -->
                                  <strong v-if="value == 30 && companyData[k].type == 'inner'" style="color: white">LV. 1</strong>
                                  <strong v-if="value == 60 && companyData[k].type == 'inner'" style="color: white">LV. 2</strong>
                                  <strong v-if="value == 70 && companyData[k].type == 'inner'" style="color: white">LV. 2</strong>
                                  <strong v-if="value == 100 && companyData[k].type == 'inner'" style="color: white">LV. 3</strong>
                                  <!-- พนักงานภายนอก -->
                                  <strong v-if="value == 50 && companyData[k].type == 'outer'" style="color: white">LV. 1</strong>
                                  <strong v-if="value == 100 &&companyData[k].type == 'outer'" style="color: white">LV. 2</strong>
                                  <span class="progress-bar-txt">
                                    {{value}}%
                                  </span>
                                 </template>
                              </v-progress-linear>
                              </v-col>
                          </v-row>
                  <v-row no-gutters class="mt-5 pa-3">
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                     <p class="txt-font">ประเภทพนักงาน</p>
                      <span class="txt-font" style="color: #333;" v-if="companyData[k].type === 'inner'">พนักงานภายใน</span>
                      <span class="txt-font" style="color: #333;" v-if="companyData[k].type === 'outer'">พนักงานภายนอก</span>
                    </v-col>
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font">บริษัท</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].companyFullNameTh}}</span>
                    </v-col>
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-0 mt-md-0 mt-sm-6">รหัสพนักงาน</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].employeeId}}</span>
                    </v-col>

                  <!-- </v-row>
                  <v-row no-gutters class="mt-8 pa-3"> -->
                     <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-10 mt-sm-6">ตำแหน่ง</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].positionName}}</span>
                    </v-col>
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-10 mt-sm-6">สายงาน</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].workLine}}</span>
                    </v-col>
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-10 mt-sm-6">ฝ่ายงาน</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].department}}</span>
                    </v-col>

                  <!-- </v-row>
                  <v-row no-gutters class="mt-8 pa-3"> -->
                     <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-10 mt-sm-6">ส่วนงาน</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].section}}</span>
                    </v-col>
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-10 mt-sm-6">วันที่เริ่มงาน</p>
                      <span class="txt-font" style="color: #333;">{{formatBirthDate(companyData[k].startWorkDate)}}</span>
                    </v-col>
                    <v-col
                      cols="12" lg="4" md="4" sm="6"
                      class="justify-start align-start mt-3 mt-lg-0 mt-md-0 mt-md-0"
                    >
                      <p class="txt-font mt-lg-10 mt-sm-6">อายุการทำงาน</p>
                      <span class="txt-font" style="color: #333;">{{companyData[k].experience}}</span>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </div>
          </div>
        </v-row>
        <v-row align="center" justify="center" class="mt-6">
          <div class="pt-1 pb-4 rounded-0" style="min-width:50vw; width:70vw; max-width:100vw;">
            <div class="text-left">
              <span class="mr-5 text-head-back-all">ข้อมูลผู้บังคับบัญชา</span>
            </div>
            <v-divider class="mt-1 mb-4"/>
            <div>
              <v-data-table
                :headers="headers"
                :items="temploralyData"
                class="border-table-employee text-no-wrap mt-1 elevation-0"
                item-key="no"
                disable-sort
                :page.sync="page"
                :items-per-page="perPage"
                hide-default-footer
                @page-count="pageCount = $event"
              >
                <template v-slot:[`item.no`]="{ item }">
                  {{ temploralyData.indexOf(item) + 1 }}
                </template>
                <template v-slot:[`item.tempLeader`]="{ item }">
                  <span>{{ item.tempLeader || "-" }}</span>
                </template>
              </v-data-table>
              <v-row>
              <v-col cols="12" class="pa-0">
              <div class="justify-end d-flex align-end pt-4">
                <v-pagination
                  v-model="page"
                  :length="pageCount"
                  :total-visible="5"
                ></v-pagination>
              </div>
              </v-col>
            </v-row>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1"
            color="#1654C6"
            outlined
            @click="dialogDelete = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="ra-button1"
            color="#1654C6"
            dark
            @click="removeEmployee(itemConfirmDelete)"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
          <v-icon left dark small :color="snackbarColor"
            >fa-check-circle</v-icon
          >
          <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import OverlayLoading from '../../_template/OverlayLoading.vue'
// import FullLoading from '../../_template/FullLoading.vue'
// import { EventBus } from '@/EventBus'
// import swal from 'sweetalert'
import {
  // hostImageUrl,
  hostImageUrlv3
} from '@/API/API'
import moment from 'moment'
moment.locale('th')

export default {
  components: {
    OverlayLoading
  },
  name: 'create-new-employee',
  data () {
    return {
      perPage: 5,
      pageCount: 0,
      page: 1,
      level_bar: [],
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDelete: false,
      titleDialog: '',
      itemConfirmDelete: [],
      employeeData: [],
      temploralyData: [{
        no: 1
      }],
      itemIdex: 0,
      tab: null,
      items: ['ข้อมูลพนักงาน', 'ประวัติพนักงาน'],
      panel: [0, 1],
      typeText: null,
      activeTab: 1,
      loading: false,
      loadingProfileData: false,
      loadingEmployeeData: false,
      keySearchEmployee: [],
      date: new Date().toISOString().substr(0, 10),
      imgUser: null,
      imageUrl: null,
      itemDefault: [
        {
          orgChartName: 'ไม่มี',
          pid: null,
          _id: 'ไม่มี'
        }
      ],
      genderthlists: [],
      titleTH: '',
      titleEN: '',
      fnameTH: '',
      lnameTH: '',
      fnameEN: '',
      lnameEN: '',
      accountId: '',
      companyData: [],
      birthDate: moment(new Date().toISOString().substr(0, 10)).format(
        'DD/MM/YYYY'
      ),
      email: '',
      tel: '',
      companyId: '',
      companyItems: [],
      rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
      employeeId: '',
      // startWorkDate: moment(new Date().toISOString().substr(0, 10)).format('DD/MM/YYYY'),
      startWorkDate: new Date().toISOString().substr(0, 10),
      endWorkDate: new Date().toISOString().substr(0, 10),
      valid: false,
      alertText: {
        'user is already': 'มีข้อมูลผู้ใช้ในระบบแล้ว',
        'employeeId is already': 'รหัสพนักงานซ้ำ',
        'chart not found': 'ไม่พบฝ่ายงานที่ต้องการ',
        'user not found': 'ไม่พบผู้ใช้งาน',
        'request is already': 'มีคำร้องนี้ในระบบแล้ว',
        'data incomplete': 'กรุณากรอกข้อมูลให้ครบถ้วน'
      },
      alertTextDetail: {
        'user is already': 'กรุณาลองใหม่อีกครั้ง',
        'employeeId is already': 'กรุณาลองใหม่อีกครั้ง',
        'chart not found': 'กรุณาลองใหม่อีกครั้ง',
        'user not found': 'กรุณาลองใหม่อีกครั้ง',
        'request is already': 'กรุณาอนุมัติคำร้องที่มีอยู่ในระบบ'
      },
      expand: false,
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'สายบังคับบัญชา', value: 'orgChartName' },
        { text: 'บริษัท', value: 'companyFullName' },
        { text: 'ประเภท', value: 'tempLeader' }
        // { text: 'วันเวลาทำรายการ', value: 'email' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    // EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    // EventBus.$off('addAprover')
  },
  async created () {
    // this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsitems = this.$store.state.user._id
    this.propsitemsTab = this.$route.params.tab
    if (!this.$store.state.token) {
      this.goLogin()
    } else {
      await this.getEmployeeDetail(this.propsitems, this.propsitemsTab)
      // await this.getEmployeeDetail('5f87dee580c57d63cc030145', this.$route.params.tab)
    }
  },
  computed: {
    checkCompany () {
      return !!this.selectGroupCompany.length
    }
  },
  watch: {},
  methods: {
    goBack () {
      // this.$router.push('/manageemp')
    },
    gotoProfile () {
      const self = this
      self.activeTab = 1
      // console.log(self.activeTab)
    },
    async getEmployeeDetail (id, tab) {
      // const temp = []
      let urlEmp = ''
      // urlEmp = `${this.api}/api/vMonk/manageEmployee/getUserData/`
      urlEmp = `${this.api}/api/vMonk/users/profile`
      await this.axios({
        method: 'post',
        url: urlEmp,
        data: {
          userId: id
        },
        headers: {
          authorization: this.$store.state.token
        }
      })
        .then(response => {
          // this.employeeData = response.data.result.history
          // this.desserts = response.data.result
          if (response.data.success) {
            this.titleTH = response.data.user.titleTh
            this.titleEN = response.data.user.titleEn
            this.fnameTH = response.data.user.firstNameTh
            this.fnameEN = response.data.user.firstNameEn
            this.lnameTH = response.data.user.lastNameTh
            this.lnameEN = response.data.user.lastNameEn
            this.birthDate = response.data.user.birthday
            this.email = response.data.user.emailOneId
            this.tel = response.data.user.tel
            this.accountId = response.data.user.accountId
            this.userImg = response.data.user.userImg
            this.companyData = response.data.employee
            // this.userId = response.data.result._id
            if (this.userImg === '') {
              this.imageUrl = `${hostImageUrlv3}/_/${response.data.user.emailOneId}`
            } else {
              this.imageUrl = `${hostImageUrlv3}/${response.data.user.userImg}/${response.data.user.emailOneId}`
            }
            this.temploralyData = response.data.leaderOrgchart
            this.temploralyData.map((el, index) => {
              el.tempLeader = el.tempLeader === 'true' ? 'รักษาการ' : 'ผู้ดูแล'
            })
            for (let index = 0; index < this.companyData.length; index++) {
              this.level_bar.push(0)
            }
            for (let index = 0; index < this.companyData.length; index++) {
              this.manage_linear(index)
            }
            // this.dataEmployee = response.data.result.dataEmployee
            // this.dataEmployee.map((el, index) => {
            //   if (el.endWorkDate !== '') {
            //     el.endWorkDate = this.formatWorkDate(el.endWorkDate)
            //   }
            //   if (el.startWorkDate !== '') {
            //     el.startWorkDate = this.formatWorkDate(el.startWorkDate)
            //   }
            // })
            // for (let i = 0; i < this.dataEmployee.length; i++) {
            //   this.loading = false
            // }
          }
          if (tab === 'employee') {
            this.valid = true
          } else {
            this.valid = false
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name
        .substr(dotindex + 1)
        .toLowerCase()
      if (
        FileExtension === 'jpg' ||
        FileExtension === 'png' ||
        FileExtension === 'JPG' ||
        FileExtension === 'PNG'
      ) {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var imgUser = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          imgUser.src = evt.target.result
        }
      }
    },
    onImgError (i, j) {
      this.dataEmployee[i].approver[j].failed_image = true
    },
    onImgErrorEmployee (i) {
      // this.approver[i].failed_image = true
    },
    formatWorkDate (date) {
      return date ? moment(date).format('yyyy-MM-DD') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    formatDate (date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    formatBirthDate (date) {
      return date ? moment(date).format('DD/MM/YYYY') : 'ไม่มี'
      // return new Date(date) - new Date(date)
    },
    manage_linear (i) {
      if (this.companyData[i].type === 'inner') {
        var idNumber = 30
        var linework = 30
        var position = 40
        if (this.companyData[i].employeeId === '' || this.companyData[i].employeeId === null) {
          idNumber = 0
        }
        if (this.companyData[i].workLine === '' || this.companyData[i].workLine === null ||
        this.companyData[i].workLine === undefined || this.companyData[i].workLine === 'ไม่มี' ||
        this.companyData[i].workLine === '-') {
          linework = 0
        }
        if (this.companyData[i].positionName === '' || this.companyData[i].positionName === null ||
        this.companyData[i].positionName === undefined || this.companyData[i].positionName === 'ไม่มี' ||
        this.companyData[i].positionName === '-') {
          position = 0
        }
        this.level_bar[i] = Number(idNumber) + Number(linework) + Number(position)
      } else if (this.companyData[i].type === 'outer') {
        var linework2 = 50
        var position2 = 50
        if (this.companyData[i].workLine === '' || this.companyData[i].workLine === null ||
        this.companyData[i].workLine === undefined || this.companyData[i].workLine === 'ไม่มี' ||
        this.companyData[i].workLine === '-') {
          linework2 = 0
        }
        if (this.companyData[i].positionName === '' || this.companyData[i].positionName === null ||
        this.companyData[i].positionName === undefined || this.companyData[i].positionName === 'ไม่มี' ||
        this.companyData[i].positionName === '-') {
          position2 = 0
        }
        this.level_bar[i] = Number(linework2) + Number(position2)
      }
    }
  }
}
</script>
<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
</style>
<style scoped>
@import "../../../css/CreateEmployee.css";
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1),
table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #f8f9fb;
}

.v-stepper {
  box-shadow: none !important;
}
.v-stepper__header {
  box-shadow: none !important;
}
.v-application {
  padding: 0 !important;
}
.maminus-5 {
  margin: 0 -20px !important;
}
.v-stepper__step {
  flex-direction: column !important;
}
.v-application--is-ltr .v-stepper__step__step {
  margin-right: 0 !important;
}
.theme--light.v-divider {
  border-color: rgb(229, 230, 231) !important;
}
.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  padding: 24px;
  position: relative;
}
.step-container:hover {
  cursor: pointer;
}
.step-container:hover .step-circle-inactive {
  /* border: 2px solid rgb(122, 212, 108) !important; */
  border: 2px solid #004682 !important;
}
.step-container:hover .step-circle-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-container:hover .step-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-circle-active {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  /* border: 2px solid rgb(103, 173, 92) !important; */
  border: 2px solid #07d1bf !important;
}
.step-circle-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-circle-inactive {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  border: 2px solid rgb(229, 230, 231) !important;
}
.step-circle-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.step-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.container-profile {
  border-radius: 15px;
  border: 1px solid rgb(229, 230, 231);
  background-color: #fff;
}
div.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
div.v-messages {
  min-height: 0 !important;
}
.txt-font-label {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 5px;
  color: #757575;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.ra-span-text-highlight {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Neutral / #333333 */

  color: #333333;
}
.ra-layout-empty {
  height: 640px;
  left: 32px;
  right: 32px;
  top: 164px;
}
.ra-head-text-bold {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654c6;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.ra-border-button {
  background: #ffffff;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #eeeeee;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: "Sarabun", sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.v-progress-linear {
  border-radius: 12px;
  margin: 0 /* remove margin as the txt will create that margin */
}
.progress-bar-txt {
  z-index: 1;
  position: absolute;
  right: 10px;
  color: white;
}
.level-title {
  font-size: 1.1rem !important;
  margin-top: 20px;
}
</style>
